export const stripWrappingTag = (html: string) => html.replace(/^<[^>]+>|<\/[^>]+>$/g, "");

/** Removes every HTML tag, keeping only text content — for plain-text contexts */
export const stripAllTags = (html = "") => html.replace(/<[^>]+>/g, "");

const HTML_ENTITIES: Record<string, string> = {
	"&amp;": "&",
	"&lt;": "<",
	"&gt;": ">",
	"&quot;": '"',
	"&#39;": "'",
};

/** Decodes the CMS HTML entities (`&amp; &lt; &gt; &quot; &#39;`) to plain text in a single pass. */
export const unescapeHtml = (value = "") =>
	value.replace(/&(?:amp|lt|gt|quot|#39);/g, entity => HTML_ENTITIES[entity]);
